module.exports = __webpack_public_path__ + "static/img/dash-stat-today.ed1a6ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dash-stat-today.png
// module id = P/gb
// module chunks = 1